import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
export class AttachedGap extends AttachedContent {
    type = 'gap';
}
